import React from 'react';
import { ArrowUpRight, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer-new">
      {/* CTA Section */}
      <div className="footer-cta">
        <div className="footer-cta-content">
          <h2 className="footer-cta-title">Ready to Start Your Project?</h2>
          <p className="footer-cta-text">
            Let's collaborate and bring your vision to life with cutting-edge web solutions.
          </p>
          <button 
            className="footer-cta-button"
            onClick={() => scrollToSection('contact')}
          >
            Get In Touch <ArrowUpRight className="ml-2 h-5 w-5" />
          </button>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-container-new">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-brand-section">
              <h3 className="footer-logo-new">RM WEBWORKS</h3>
              <p className="footer-description">
                Two developers passionate about creating exceptional digital experiences 
                that drive results and exceed expectations.
              </p>
            </div>
            
            {/* Quick Links */}
            <div className="footer-column-new">
              <h4 className="footer-column-title">Quick Links</h4>
              <ul className="footer-list-new">
                <li>
                  <button onClick={() => scrollToSection('about')} className="footer-link-new">
                    About Us
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('how-we-work')} className="footer-link-new">
                    Our Process
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('projects')} className="footer-link-new">
                    Portfolio
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('contact')} className="footer-link-new">
                    Contact
                  </button>
                </li>
              </ul>
            </div>
            
            {/* Services */}
            <div className="footer-column-new">
              <h4 className="footer-column-title">Services</h4>
              <ul className="footer-list-new">
                <li><span className="footer-link-new">Web Development</span></li>
                <li><span className="footer-link-new">UI/UX Design</span></li>
                <li><span className="footer-link-new">E-Commerce Solutions</span></li>
                <li><span className="footer-link-new">API Development</span></li>
                <li><span className="footer-link-new">Web Applications</span></li>
              </ul>
            </div>
            
            {/* Contact Info */}
            <div className="footer-column-new">
              <h4 className="footer-column-title">Get In Touch</h4>
              <ul className="footer-list-new">
                <li>
                  <a href="mailto:contact@rmwebworks.in" className="footer-link-new">
                    contact@rmwebworks.in
                  </a>
                </li>
                <li>
                  <a href="tel:+919582191209" className="footer-link-new">
                    +91 9582191209
                  </a>
                </li>
                <li>
                  <a href="tel:+918826033661" className="footer-link-new">
                    +91 8826033661
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="footer-bottom-new">
        <div className="footer-container-new">
          <div className="footer-bottom-content" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <p className="footer-made-with">
              Made with <Heart className="heart-icon" style={{ display: 'inline', verticalAlign: 'middle', margin: '0 4px', width: '16px', height: '16px' }} /> by RM WEBWORKS
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
